class ProductBannerVideo extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const injectVideoObserver = new IntersectionObserver(this.#injectVideoObserverCallback.bind(this));
    injectVideoObserver.observe(this);
  }

  #injectVideoObserverCallback(entries, observer) {
    if(this.getAttribute('loaded')) {
      observer.unobserve(this);
      return;
    }
    if(!entries[0].isIntersecting) return;

    this.setAttribute('loaded', true);
    const templateContent = document.getElementById('ProductBannerVideoTemplate').content;
    this.shadowRoot.append(templateContent.cloneNode(true));
    this.videoElement = this.shadowRoot.querySelector('video');

    // Set a video element observer after the video element is injected
    const playVideoObserver = new IntersectionObserver(this.#playVideoObserverCallback.bind(this), {threshold: .75});
    playVideoObserver.observe(this);
  }

  #playVideoObserverCallback(entries) {
    if(!entries[0].isIntersecting) {
      if(this.videoElement && !this.videoElement.paused) this.videoElement.pause();
      return;
    }
    if(!this.videoElement) return;

    window.pauseAllMedia();

    this.videoElement.play();
  }
}

customElements.define('product-banner-video', ProductBannerVideo);